// extracted by mini-css-extract-plugin
export var align_center = "blog-copy-img-module--align_center--03f29";
export var align_left = "blog-copy-img-module--align_left--ff79a";
export var align_right = "blog-copy-img-module--align_right--e90cd";
export var alignmob_center = "blog-copy-img-module--alignmob_center--de891";
export var alignmob_left = "blog-copy-img-module--alignmob_left--fd1ad";
export var alignmob_right = "blog-copy-img-module--alignmob_right--4a7db";
export var caption = "blog-copy-img-module--caption--d0fc6";
export var collblock = "blog-copy-img-module--collblock--0439d";
export var content = "blog-copy-img-module--content--ca8af";
export var copy_block = "blog-copy-img-module--copy_block--4b735";
export var copy_cta = "blog-copy-img-module--copy_cta--1f59f";
export var copy_cta_link = "blog-copy-img-module--copy_cta_link--f8d37";
export var cta_img = "blog-copy-img-module--cta_img--3968a";
export var cta_link = "blog-copy-img-module--cta_link--9fcc6";
export var image = "blog-copy-img-module--image--5afbd";
export var img = "blog-copy-img-module--img--f0c1b";
export var nd_ctaLink = "blog-copy-img-module--nd_cta-link--2a639";
export var nomargin = "blog-copy-img-module--nomargin--81e21";
export var solid_btn = "blog-copy-img-module--solid_btn--0b6b2";
export var story_copyCta_img = "blog-copy-img-module--story_copy-cta_img--3823e";
export var text = "blog-copy-img-module--text--8d031";
export var title = "blog-copy-img-module--title--cf235";
export var with_image = "blog-copy-img-module--with_image--886b7";